import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { RecurringInvoiceFooterProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { RouteConstants } from "utils/constants";
//#endregion
//#region components
import { PageFooter } from "components/common";
import RecurringInvoiceMoreActions from "../actions/recurringMoreActions";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const RecurringInvoiceFooter: React.FC<RecurringInvoiceFooterProps> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const onInvoiceEdit = async () => {
    navigate(
      UrlHelper.formatPath(`/Invoice/Create?${RouteConstants.QueryParamStrings.Recurring}=${props.invoice.id}`),
      {
        state: { background: location },
      }
    );
  };

  const onInvoiceSave = async () => {
    return props.createOrUpdateInvoice && props.createOrUpdateInvoice();
  };

  return (
    <PageFooter
      actions={
        props.invoice.status !== WintSuperkollAPIModel.RecurringInvoiceState.Stopped
          ? [
              {
                text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ChangeInvoice),
                onClick: onInvoiceEdit,
                type: StyleEnums.DisplayType.Info,
              },
              {
                text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
                onClick: onInvoiceSave,
                type: StyleEnums.DisplayType.Success,
                onActionSuccess: props.reloadHandler,
                isDisabled: !props.isValid,
              },
            ]
          : []
      }
      moreActions={
        <RecurringInvoiceMoreActions
          invoice={props.invoice}
          reloadHandler={props.reloadHandler}
          markAsDoneHandler={props.markAsDoneHandler}
        />
      }
      columnsLeft={props.columnsLeft}
    />
  );
};

export default RecurringInvoiceFooter;
